import styled, { css } from "styled-components";
import ColoredPaper from "../../surface/ColoredPaper/ColoredPaper";

export const BaseCardRoot = styled(ColoredPaper)(
    ({ theme }) => css`
        width: 100%;
        border-radius: ${theme.borderRadius};
        padding: ${theme.spacing.all(8, 6)};
    `,
);
